import { render } from "./StartSurvey.vue?vue&type=template&id=50c7f396"
import script from "./StartSurvey.vue?vue&type=script&lang=js"
export * from "./StartSurvey.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__